import React, { useState, useEffect } from 'react';
import { auth } from '../firebase'; // Import auth from your firebase.js

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Listen for auth state changes (user login status)
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsLoggedIn(true); // User is logged in
      } else {
        setIsLoggedIn(false); // User is not logged in
      }
    });

    // Clean up the listener on unmount
    return () => unsubscribe();
  }, []);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    // Check if the new passwords match
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    if (isLoggedIn) {
      const user = auth.currentUser;

      if (!user) {
        setError('No user is currently logged in.');
        return;
      }

      try {
        // Directly update the password
        await user.updatePassword(newPassword);

        setSuccessMessage('Password updated successfully!');
        setError(''); // Clear any previous errors
      } catch (err) {
        setError('Failed to update password: ' + err.message);
      }
    } else {
      setError('Please log in to change your password.');
    }
  };

  return (
    <div className="login-container">
    <div className="login-box">
      <h2>Change Your Password</h2>
      {error && <p className="error-message">{error}</p>}
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handlePasswordChange} className="loginf-email-login-form">
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Enter your current password"
          required
          className="loginf-email-input"
        />
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Enter new password"
          required
          className="loginf-email-input"
        />
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          required
          className="loginf-email-input"
        />
        <button type="submit" className="loginf-submit-button">Change Password</button>
      </form>
    </div>
  </div>
  );
};

export default ChangePassword;
